import { usePayments } from '@/hooks/api-hooks';
import PaymentsTable, { getPaymentAllocated } from '@/components/payments-table';
import type { Business } from '@turizi/shared';
import { useTranslation } from 'react-i18next';
import { Loader, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconCashBanknote, IconWand } from '@tabler/icons-react';
import AutoAssignPaymentsModal from '@/components/auto-assign-payments-modal';

interface Props {
    business?: Business;
}

export const getPaymentAllocatedAmount = getPaymentAllocated;

export default function BusinessPaymentsTab({ business }: Props): JSX.Element {
    const { t } = useTranslation();
    const [autoAssignOpened, { open: openAutoAssignModal, close: closeAutoAssignModal }] = useDisclosure(false);

    const {
        data: paymentsRes,
        isLoading: isLoadingPayments
    } = usePayments(business?.id ? { business_id: business.id } : {});

    const payments = paymentsRes?.data || [];

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between gap-2.5 mb-2 border-b border-slate-100 pb-2">
                <div className="flex items-center gap-2.5">
                    <div className="p-1.5 bg-emerald-50 rounded-lg text-emerald-650 shrink-0">
                        <IconCashBanknote size={16} stroke={2} />
                    </div>
                    <div className="flex items-center gap-2">
                        <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wider">{t('payments')}</h3>
                        {isLoadingPayments && <Loader size="xs" color="black" />}
                    </div>
                </div>

                <Button
                    size="xs"
                    variant="filled"
                    color="black"
                    leftSection={<IconWand size={14} />}
                    onClick={openAutoAssignModal}
                    className="font-bold shadow-2xs"
                >
                    {t('auto_assign_payments')}
                </Button>
            </div>

            <PaymentsTable payments={payments} />

            <AutoAssignPaymentsModal
                opened={autoAssignOpened}
                onClose={closeAutoAssignModal}
                businessId={business?.id}
            />
        </div>
    );
}
